(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
    'use strict';
    
    let isUpdating = false;
    let eventsBound = false;
    
    function getElement(selector) {
        return document.querySelector(selector);
    }
    
    function getAllElements(selector) {
        return document.querySelectorAll(selector);
    }
    
    function addEvent(element, event, handler) {
        if (element) {
            element.addEventListener(event, handler);
        }
    }
    
    function addEventDelegation(parent, selector, event, handler) {
        if (parent) {
            parent.addEventListener(event, function(e) {
                let target = e.target;
                
                if (target.matches && target.matches(selector)) {
                    handler.call(target, e);
                    return;
                }
                
                target = e.target.closest(selector);
                if (target) {
                    handler.call(target, e);
                }
            });
        }
    }
    
    function handleQuantityChange(e) {
        e.preventDefault();
        e.stopPropagation();
        let button = e.target;
        if (!button.hasAttribute('data-action')) {
            button = e.target.closest('.quantity__minus, .quantity__plus');
        }
        
        if (!button) return;
        
        const action = button.getAttribute('data-action');
        const itemKey = button.getAttribute('data-item-key');
        const input = getElement('input[data-item-key="' + itemKey + '"]');
        
        if (!input) return;
        
        if (button.disabled) return;
        button.disabled = true;
        
        let currentValue = parseInt(input.value) || 1;
        let newValue = currentValue;
        
        if (action === 'increase') {
            newValue = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 1) {
            newValue = currentValue - 1;
        }
        
        input.value = newValue;
        
        setTimeout(function() {
            button.disabled = false;
        }, 300);
        
        updateCart();
    }
    
    function handleQuantityInput(e) {
        const input = e.currentTarget;
        const value = parseInt(input.value) || 1;
        
        if (value < 1) {
            input.value = 1;
        } else {
            input.value = value;
        }
        
        if (e.type === 'blur') {
            updateCart();
        }
    }
    
    function updateCart() {
        if (isUpdating) return;
        isUpdating = true;
        
        const form = getElement('#cart-form');
        if (form) {
            setTimeout(function() {
                const inputs = getAllElements('input[name="updates[]"]');
                for (let i = 0; i < inputs.length; i++) {
                    const input = inputs[i];
                    const value = parseInt(input.value);
                    if (isNaN(value) || value < 1) {
                        input.value = 1;
                    }
                }
                form.submit();
                
                setTimeout(function() {
                    isUpdating = false;
                }, 1000);
            }, 300);
        } else {
            isUpdating = false;
        }
    }
    
    function initCart() {
        if (eventsBound) return;
        
        addEventDelegation(document, '.quantity__minus, .quantity__plus', 'click', handleQuantityChange);
        
        const quantityButtons = getAllElements('.quantity__minus, .quantity__plus');
        for (let i = 0; i < quantityButtons.length; i++) {
            const button = quantityButtons[i];
            addEvent(button, 'click', handleQuantityChange);
        }
        
        const quantityInputs = getAllElements('.quantity__input');
        for (let i = 0; i < quantityInputs.length; i++) {
            const input = quantityInputs[i];
            addEvent(input, 'change', handleQuantityInput);
            addEvent(input, 'blur', handleQuantityInput);
        }
        
        eventsBound = true;
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCart);
    } else {
        initCart();
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-deals"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const categoryButtons = document.querySelectorAll('.category-filter-btn');
    const productGrid = document.getElementById('productGrid');
    const productItems = document.querySelectorAll('.product-item');
    const searchInput = document.getElementById('searchInput');
    const searchButton = document.getElementById('searchButton');
    const searchForm = document.getElementById('searchForm');
    const resultCountSpan = document.getElementById('resultCount');

    if (!productGrid) {
        return;
    }
    
    let currentCategoryFilter = 'all';
    let currentSearchQuery = '';
    
    const noResultsDiv = document.createElement('div');
    noResultsDiv.className = 'no-results hidden col-12';
    noResultsDiv.innerHTML = `
        <h3>${window.hotDealsTranslations.noProductsFound}</h3>
        <p>${window.hotDealsTranslations.noProductsMessage}</p>
    `;
    productGrid.appendChild(noResultsDiv);
    
    function filterProducts(categoryFilter = currentCategoryFilter, searchQuery = currentSearchQuery) {
        let visibleCount = 0;
        const normalizedSearchQuery = searchQuery.toLowerCase().trim();
        
        productItems.forEach(item => {
            const productType = item.dataset.productType;
            const productCollections = item.dataset.productCollections;
            const productTags = item.dataset.productTags;
            const productTitle = item.dataset.productTitle;
            const productVendor = item.dataset.productVendor;
            
            let shouldShowByCategory = false;
            let shouldShowBySearch = false;
            
            if (categoryFilter === 'all') {
                shouldShowByCategory = true;
            } else if (categoryFilter.startsWith('collection-')) {
                shouldShowByCategory = productCollections && productCollections.includes(categoryFilter);
            } else {
                shouldShowByCategory = productType === categoryFilter;
            }
            
            if (normalizedSearchQuery === '') {
                shouldShowBySearch = true;
            } else {
                shouldShowBySearch = (
                    productTitle.includes(normalizedSearchQuery) ||
                    productVendor.includes(normalizedSearchQuery) ||
                    productType.includes(normalizedSearchQuery) ||
                    productTags.includes(normalizedSearchQuery)
                );
            }
            
            if (shouldShowByCategory && shouldShowBySearch) {
                item.classList.remove('hidden');
                visibleCount++;
            } else {
                item.classList.add('hidden');
            }
        });
        
        if (visibleCount === 0) {
            noResultsDiv.classList.remove('hidden');
        } else {
            noResultsDiv.classList.add('hidden');
        }
        
        return visibleCount;
    }
    
    function updateActiveButton(activeButton) {
        categoryButtons.forEach(btn => btn.classList.remove('active'));
        activeButton.classList.add('active');
    }
    
    function updateResultCount(count) {
        if (resultCountSpan) {
            if (count === 0) {
                resultCountSpan.textContent = 'No results found';
            } else {
                resultCountSpan.textContent = `Showing 1-${count} of ${count} result${count !== 1 ? 's' : ''}`;
            }
        }
    }
    
    function performSearch(searchQuery = '') {
        currentSearchQuery = searchQuery;
        if (searchButton) {
            searchButton.classList.add('loading');
        }
        productGrid.classList.add('filter-loading');
        
        setTimeout(() => {
            const visibleCount = filterProducts(currentCategoryFilter, currentSearchQuery);
            updateResultCount(visibleCount);
            
            if (searchButton) {
                searchButton.classList.remove('loading');
            }
            productGrid.classList.remove('filter-loading');
        }, 300);
    }

    if (searchForm && searchInput && searchButton) {
        searchForm.addEventListener('submit', function(e) {
            e.preventDefault();
            performSearch(searchInput.value);
        });

        searchButton.addEventListener('click', function(e) {
            e.preventDefault();
            performSearch(searchInput.value);
        });

        let searchTimeout;
        searchInput.addEventListener('input', function() {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                performSearch(this.value);
            }, 300);
        });

        searchInput.addEventListener('keyup', function(e) {
            if (e.key === 'Escape' || this.value === '') {
                this.value = '';
                performSearch('');
            }
        });
    }
    
    categoryButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const filterValue = this.dataset.filter;
            const clickedButton = this;
            currentCategoryFilter = filterValue;
            
            clickedButton.classList.add('loading');
            productGrid.classList.add('filter-loading');
            
            categoryButtons.forEach(btn => btn.style.pointerEvents = 'none');
            
            setTimeout(() => {
                const visibleCount = filterProducts(currentCategoryFilter, currentSearchQuery);
                updateActiveButton(clickedButton);
                updateResultCount(visibleCount);
                
                clickedButton.classList.remove('loading');
                productGrid.classList.remove('filter-loading');
                
                categoryButtons.forEach(btn => btn.style.pointerEvents = 'auto');
            }, 300);
        });
    });
    
    const initialCount = filterProducts('all', '');
    updateResultCount(initialCount);
    });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.partner-hub');
    if (!root) return;

    const form = root.querySelector('#PartnerHubContactForm');
    if (!form) return;

    const steps = Array.from(form.querySelectorAll('[data-step-panel]'));
    const indicators = Array.from(form.querySelectorAll('[data-step-indicator]'));
    const nextButtons = Array.from(form.querySelectorAll('[data-step-next]'));
    const prevButtons = Array.from(form.querySelectorAll('[data-step-prev]'));
    const errorBox = form.querySelector('#PartnerStepError');
    const progressBar = form.querySelector('#PartnerProgressBar');
    const selectedProductsField = form.querySelector('#PartnerSelectedProducts');
    const mailtoRecipientField = form.querySelector('#PartnerMailtoRecipient');
    const mailtoSubjectField = form.querySelector('#PartnerMailtoSubject');
    const summaryBox = form.querySelector('#PartnerSummary p');
    const checkboxes = Array.from(form.querySelectorAll('.partner-product-check'));
    const unitSelects = Array.from(form.querySelectorAll('.partner-product-unit'));
    const productCards = Array.from(form.querySelectorAll('[data-product-card]'));
    const categoryButtons = Array.from(form.querySelectorAll('[data-category-filter]'));
    const searchInput = form.querySelector('#PartnerProductSearch');
    const catalogCount = form.querySelector('#PartnerCatalogCount');
    const emptyState = form.querySelector('#PartnerProductsEmpty');
    const loadMoreButton = form.querySelector('#PartnerLoadMoreProducts');
    const catalogInitialLimit = Math.max(Number(root.dataset.catalogInitialLimit) || 8, 1);
    const catalogLoadStep = Math.max(Number(root.dataset.catalogLoadStep) || 8, 1);
    let visibleProductsLimit = catalogInitialLimit;
    let activeCategory = 'all';

    const getStepByNumber = (stepNumber) => steps.find((step) => Number(step.dataset.stepPanel) === stepNumber);
    const getCurrentStepNumber = () => Number(form.dataset.currentStep || 1);
    const normalizeText = (value = '') => value.toString().toLowerCase().trim();

    const setError = (message = '') => {
      if (!errorBox) return;
      if (!message) {
        errorBox.hidden = true;
        errorBox.textContent = '';
        return;
      }
      errorBox.hidden = false;
      errorBox.textContent = message;
    };

    const filterProducts = ({ resetLimit = false } = {}) => {
      if (resetLimit) {
        visibleProductsLimit = catalogInitialLimit;
      }

      const searchTerm = normalizeText(searchInput ? searchInput.value : '');
      const matchedCards = [];

      productCards.forEach((card) => {
        const cardCategory = normalizeText(card.dataset.category || 'other');
        const cardTitle = normalizeText(card.dataset.title || '');
        const matchesCategory = activeCategory === 'all' || cardCategory === activeCategory;
        const matchesSearch = !searchTerm || cardTitle.includes(searchTerm);
        if (matchesCategory && matchesSearch) {
          matchedCards.push(card);
        }
      });

      productCards.forEach((card) => {
        card.classList.add('is-hidden');
      });

      matchedCards.forEach((card, index) => {
        card.classList.toggle('is-hidden', index >= visibleProductsLimit);
      });

      const visibleCount = Math.min(matchedCards.length, visibleProductsLimit);
      if (catalogCount) {
        catalogCount.textContent = `Showing ${visibleCount} of ${matchedCards.length} products`;
      }

      if (emptyState) {
        emptyState.hidden = matchedCards.length > 0;
      }

      if (loadMoreButton) {
        const remainingCount = matchedCards.length - visibleCount;
        loadMoreButton.hidden = remainingCount <= 0;
        if (remainingCount > 0) {
          loadMoreButton.textContent = `Load more products (${remainingCount} more)`;
        }
      }
    };

    const setStep = (stepNumber) => {
      form.dataset.currentStep = String(stepNumber);

      steps.forEach((step) => {
        step.classList.toggle('is-active', Number(step.dataset.stepPanel) === stepNumber);
      });

      indicators.forEach((indicator) => {
        const indicatorStep = Number(indicator.dataset.stepIndicator);
        indicator.classList.toggle('is-active', indicatorStep === stepNumber);
        indicator.classList.toggle('is-complete', indicatorStep < stepNumber);
      });

      if (progressBar) {
        const ratio = steps.length > 0 ? (stepNumber / steps.length) * 100 : 100;
        progressBar.style.width = `${ratio}%`;
      }

      setError('');
      updateSummary();
    };

    const syncProductCardState = (checkbox) => {
      const qtyInput = form.querySelector(`.partner-product-qty[data-qty-for="${checkbox.value}"]`);
      const unitInput = form.querySelector(`.partner-product-unit[data-unit-for="${checkbox.value}"]`);
      if (qtyInput) {
        qtyInput.disabled = !checkbox.checked;
        if (checkbox.checked && Number(qtyInput.value) < 1) {
          qtyInput.value = '1';
        }
      }
      if (unitInput) {
        unitInput.disabled = !checkbox.checked;
      }

      const card = checkbox.closest('[data-product-card]');
      if (card) {
        card.classList.toggle('is-selected', checkbox.checked);
      }
    };

    const validateRequiredFields = (stepElement) => {
      const requiredFields = Array.from(stepElement.querySelectorAll('[required]'));
      for (const field of requiredFields) {
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
          field.reportValidity();
          return false;
        }

        if (typeof field.value === 'string' && field.value.trim() === '') {
          field.reportValidity();
          return false;
        }
      }
      return true;
    };

    const getSelectedProductsList = () => {
      const selected = [];
      checkboxes.forEach((checkbox) => {
        if (!checkbox.checked) return;
        const productId = checkbox.value;
        const productTitle = checkbox.dataset.productTitle || 'Product';
        const qtyInput = form.querySelector(`.partner-product-qty[data-qty-for="${productId}"]`);
        const unitInput = form.querySelector(`.partner-product-unit[data-unit-for="${productId}"]`);
        const qty = Math.max(Number(qtyInput ? qtyInput.value : 1) || 1, 1);
        const unit = (unitInput && unitInput.value) || 'Case';
        const unitLabel = qty > 1 ? `${unit}s` : unit;
        selected.push(`${productTitle} - ${qty} ${unitLabel}`);
      });

      const customProducts = (form.querySelector('#Partner-custom-products')?.value || '').trim();
      if (customProducts) {
        selected.push(`Custom notes: ${customProducts}`);
      }

      return selected;
    };

    const syncSelectedProducts = () => {
      const selected = getSelectedProductsList();
      if (selectedProductsField) {
        selectedProductsField.value = selected.join(' | ');
      }
      return selected;
    };

    const validateProductsStep = () => {
      const selected = getSelectedProductsList();
      if (selected.length === 0) {
        setError('Select at least one wholesale product line or add custom product notes before continuing.');
        return false;
      }
      return true;
    };

    const validateStep = (stepNumber) => {
      const step = getStepByNumber(stepNumber);
      if (!step) return false;

      if (!validateRequiredFields(step)) {
        return false;
      }

      if (stepNumber === 2 && !validateProductsStep()) {
        return false;
      }

      setError('');
      return true;
    };

    const getFieldValue = (selector) => {
      const field = form.querySelector(selector);
      return ((field && field.value) || '').trim();
    };

    const buildMailtoLink = () => {
      const recipient = ((mailtoRecipientField && mailtoRecipientField.value) || '').trim().replace(/\s+/g, '');
      if (!recipient) {
        setError('Recipient email is missing. Please set it in Partner Hub section settings.');
        return '';
      }

      const baseSubject = ((mailtoSubjectField && mailtoSubjectField.value) || 'Partner request from storefront').trim();
      const legalName = getFieldValue('#Partner-company-legal');
      const subject = legalName ? `${baseSubject} - ${legalName}` : baseSubject;
      const selectedProducts = getSelectedProductsList();
      const tradeTermsAccepted = form.querySelector('#Partner-trade-terms')?.checked ? 'Accepted' : 'Not accepted';

      const mailLines = [
        'B2B Wholesale RFQ',
        '',
        '=== Company Profile ===',
        `Contact person: ${getFieldValue('#Partner-name') || '-'}`,
        `Business email: ${getFieldValue('#Partner-email') || '-'}`,
        `Phone: ${getFieldValue('#Partner-phone') || '-'}`,
        `Buyer role: ${getFieldValue('#Partner-role') || '-'}`,
        `Company legal name: ${getFieldValue('#Partner-company-legal') || '-'}`,
        `Trading name: ${getFieldValue('#Partner-company') || '-'}`,
        `VAT / Tax ID: ${getFieldValue('#Partner-vat') || '-'}`,
        `Commercial registration: ${getFieldValue('#Partner-registration') || '-'}`,
        `Country: ${getFieldValue('#Partner-country') || '-'}`,
        `Delivery countries: ${getFieldValue('#Partner-delivery-countries') || '-'}`,
        `Website / Social: ${getFieldValue('#Partner-website') || '-'}`,
        '',
        '=== RFQ Product Mix ===',
        `Business type: ${getFieldValue('#Partner-business-type') || '-'}`,
        `Expected monthly spend: ${getFieldValue('#Partner-monthly-spend') || '-'}`,
        `Monthly volume: ${getFieldValue('#Partner-volume') || '-'}`,
        `Selected products: ${selectedProducts.length ? selectedProducts.join(', ') : '-'}`,
        `Custom product notes: ${getFieldValue('#Partner-custom-products') || '-'}`,
        '',
        '=== Commercial & Logistics ===',
        `Payment terms: ${getFieldValue('#Partner-payment-terms') || '-'}`,
        `Payment method: ${getFieldValue('#Partner-payment-method') || '-'}`,
        `Shipping terms: ${getFieldValue('#Partner-shipping-terms') || '-'}`,
        `Delivery city / port: ${getFieldValue('#Partner-destination') || '-'}`,
        `Target PO value: ${getFieldValue('#Partner-budget') || '-'}`,
        `Preferred timeframe: ${getFieldValue('#Partner-timeframe') || '-'}`,
        `Trade terms acceptance: ${tradeTermsAccepted}`,
        '',
        '=== Additional Details ===',
        getFieldValue('#Partner-message') || '-',
        '',
        `Page URL: ${window.location.href}`,
      ];

      const encodedSubject = encodeURIComponent(subject);
      const encodedBody = encodeURIComponent(mailLines.join('\n'));
      return `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
    };

    const updateSummary = () => {
      if (!summaryBox) return;
      const selectedProducts = syncSelectedProducts();

      const summary = [
        `Contact: ${form.querySelector('#Partner-name')?.value || '-'}`,
        `Business email: ${form.querySelector('#Partner-email')?.value || '-'}`,
        `Legal name: ${form.querySelector('#Partner-company-legal')?.value || '-'}`,
        `Buyer role: ${form.querySelector('#Partner-role')?.value || '-'}`,
        `VAT / Tax ID: ${form.querySelector('#Partner-vat')?.value || '-'}`,
        `Country: ${form.querySelector('#Partner-country')?.value || '-'}`,
        `Delivery countries: ${form.querySelector('#Partner-delivery-countries')?.value || '-'}`,
        `Business type: ${form.querySelector('#Partner-business-type')?.value || '-'}`,
        `Monthly spend: ${form.querySelector('#Partner-monthly-spend')?.value || '-'}`,
        `Payment terms: ${form.querySelector('#Partner-payment-terms')?.value || '-'}`,
        `Shipping terms: ${form.querySelector('#Partner-shipping-terms')?.value || '-'}`,
        `Selected products: ${selectedProducts.length ? selectedProducts.join(', ') : '-'}`,
      ];

      summaryBox.textContent = summary.join('\n');
    };

    checkboxes.forEach((checkbox) => {
      syncProductCardState(checkbox);
      checkbox.addEventListener('change', () => {
        syncProductCardState(checkbox);
        updateSummary();
      });
    });

    Array.from(form.querySelectorAll('.partner-product-qty')).forEach((qtyInput) => {
      qtyInput.addEventListener('input', () => {
        const numericValue = Math.max(Number(qtyInput.value) || 1, 1);
        qtyInput.value = String(numericValue);
        updateSummary();
      });
    });

    unitSelects.forEach((unitSelect) => {
      unitSelect.addEventListener('change', updateSummary);
    });

    const summaryFields = [
      '#Partner-name',
      '#Partner-email',
      '#Partner-phone',
      '#Partner-role',
      '#Partner-company-legal',
      '#Partner-company',
      '#Partner-vat',
      '#Partner-registration',
      '#Partner-country',
      '#Partner-delivery-countries',
      '#Partner-website',
      '#Partner-business-type',
      '#Partner-monthly-spend',
      '#Partner-payment-terms',
      '#Partner-payment-method',
      '#Partner-shipping-terms',
      '#Partner-destination',
      '#Partner-volume',
      '#Partner-custom-products',
      '#Partner-budget',
      '#Partner-timeframe',
      '#Partner-message',
      '#Partner-trade-terms'
    ];
    summaryFields.forEach((selector) => {
      const field = form.querySelector(selector);
      if (field) {
        field.addEventListener('input', updateSummary);
        field.addEventListener('change', updateSummary);
      }
    });

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = normalizeText(button.dataset.categoryFilter || 'all');
        categoryButtons.forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });
        filterProducts({ resetLimit: true });
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        filterProducts({ resetLimit: true });
      });
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        visibleProductsLimit += catalogLoadStep;
        filterProducts();
      });
    }

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const currentStepElement = button.closest('[data-step-panel]');
        const currentStep = Number(currentStepElement?.dataset.stepPanel || getCurrentStepNumber());
        if (!validateStep(currentStep)) return;
        setStep(Math.min(currentStep + 1, steps.length));
      });
    });

    prevButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const currentStepElement = button.closest('[data-step-panel]');
        const currentStep = Number(currentStepElement?.dataset.stepPanel || getCurrentStepNumber());
        setStep(Math.max(currentStep - 1, 1));
      });
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const currentStep = getCurrentStepNumber();
      if (currentStep !== 3) {
        setStep(3);
        return;
      }

      if (!validateStep(2)) {
        setStep(2);
        return;
      }

      if (!validateStep(3)) {
        return;
      }

      syncSelectedProducts();
      updateSummary();

      const mailtoLink = buildMailtoLink();
      if (!mailtoLink) {
        return;
      }

      window.location.href = mailtoLink;
    });

    filterProducts({ resetLimit: true });
    setStep(1);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(() => {
  if (window.__searchCardCartSyncInit) return;
  window.__searchCardCartSyncInit = true;

  document.addEventListener('DOMContentLoaded', () => {
    const searchCards = document.querySelectorAll('.product-card');

    for (const card of searchCards) {
      const addBtn = card.querySelector('.add-to-cart-btn');
      if (!addBtn) continue;

      const productId = addBtn.dataset.productId;
      const btnText = card.querySelector('.btn-text');
      const btnLoader = card.querySelector('.btn-loader');
      const counter = card.querySelector('.quantity-counter');
      const qtyValue = card.querySelector('.qty-value');
      const plus = card.querySelector('.qty-plus');
      const minus = card.querySelector('.qty-minus');

      if (!productId || !btnText || !btnLoader || !counter || !qtyValue || !plus || !minus) {
        continue;
      }

      let isUpdating = false;
      let currentItemKey = null;

      const updateVisibility = (quantity) => {
        const qty = Number(quantity) || 0;
        if (qty > 0) {
          qtyValue.textContent = String(qty);
          addBtn.classList.add('hidden');
          counter.classList.remove('hidden');
          return;
        }
        addBtn.classList.remove('hidden');
        counter.classList.add('hidden');
      };

      const showLoading = () => {
        btnText.classList.add('hidden');
        btnLoader.classList.remove('hidden');
        addBtn.disabled = true;
      };

      const hideLoading = () => {
        btnText.classList.remove('hidden');
        btnLoader.classList.add('hidden');
        addBtn.disabled = false;
      };

      const syncQuantityFromCart = async () => {
        try {
          const res = await fetch('/cart.js', { credentials: 'same-origin' });
          if (!res.ok) {
            return Number(qtyValue.textContent) || 0;
          }
          const cart = await res.json();
          const item = cart.items.find((i) => String(i.id) === String(productId));
          currentItemKey = item ? item.key : null;
          const qty = item ? item.quantity : 0;
          updateVisibility(qty);
          return qty;
        } catch (e) {
          return Number(qtyValue.textContent) || 0;
        }
      };

      const changeQuantity = async (nextQty) => {
        try {
          if (!currentItemKey) {
            await syncQuantityFromCart();
          }

          if (!currentItemKey) {
            return false;
          }

          const safeQty = Math.max(Number(nextQty) || 0, 0);
          const payload = { updates: {} };
          payload.updates[currentItemKey] = safeQty;

          const response = await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error('Cart change failed');
          }

          const cart = await response.json();
          const item = cart.items.find((i) => i.key === currentItemKey || String(i.id) === String(productId));
          currentItemKey = item ? item.key : null;
          updateVisibility(item ? item.quantity : 0);
          return true;
        } catch (e) {
          await syncQuantityFromCart();
          return false;
        }
      };

      const withLock = async (task) => {
        if (isUpdating) return;
        isUpdating = true;
        addBtn.disabled = true;
        plus.disabled = true;
        minus.disabled = true;

        try {
          await task();
        } finally {
          isUpdating = false;
          addBtn.disabled = false;
          plus.disabled = false;
          minus.disabled = false;
        }
      };

      syncQuantityFromCart();

      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        await withLock(async () => {
          showLoading();

          try {
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: productId, quantity: 1 })
            });

            if (!addResponse.ok) {
              throw new Error('Add to cart failed');
            }

            await syncQuantityFromCart();
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:item-added'));

            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else {
              const drawer = document.getElementById('cartDrawer');
              const overlay = document.getElementById('cartOverlay');
              if (drawer && overlay) {
                drawer.classList.remove('translate-x-full');
                overlay.classList.remove('hidden');
              } else if (typeof toggleCartDrawer === 'function') {
                toggleCartDrawer();
              }
            }
          } catch (e) {
            console.error('Error adding item to cart:', e);
          } finally {
            hideLoading();
          }
        });
      });

      plus.addEventListener('click', async () => {
        await withLock(async () => {
          const nextQty = (Number(qtyValue.textContent) || 0) + 1;
          const changed = await changeQuantity(nextQty);
          if (changed) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:item-changed'));
          }
        });
      });

      minus.addEventListener('click', async () => {
        await withLock(async () => {
          const nextQty = Math.max((Number(qtyValue.textContent) || 0) - 1, 0);
          const changed = await changeQuantity(nextQty);
          if (changed) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:item-changed'));
          }
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"]) return;
  try {
    
const track = document.querySelector('.text-slider-track');
track.addEventListener('mouseover', () => {
  track.style.animationPlayState = 'paused';
});
track.addEventListener('mouseout', () => {
  track.style.animationPlayState = 'running';
});

  } catch(e) { console.error(e); }
})();
})();
